import { PORTION_TYPES } from '@/api/resources/portionTypeService'
import { SUBPORTION_TYPES } from '@/api/resources/subportionTypes'
import { COREENTITY_VALUES } from '@/api/resources/incident/incidentServices'
import { ARCHIVE_GROUPED_OPERATIONS } from '@/modules/archiveModule/services/archiveService'

export const ARCHIVE_TASK = {
    SAMPLES_TO_BE_ARCHIVED: {
        id: 'SAMPLES_TO_BE_ARCHIVED',
        url: 'cases/samples/pendingToBeArchived',
        areElementsArchived: false,
        entityType: COREENTITY_VALUES.SAMPLE,
        operations: ARCHIVE_GROUPED_OPERATIONS.SAMPLE_ARCHIVE_OPERATIONS
    },
    SAMPLES_TO_BE_UNARCHIVED: {
        id: 'SAMPLES_TO_BE_UNARCHIVED',
        url: 'cases/samples/pendingToBeUnarchived',
        areElementsArchived: true,
        areElementsPendingUnarchiving: true,
        entityType: COREENTITY_VALUES.SAMPLE,
        operations: ARCHIVE_GROUPED_OPERATIONS.SAMPLE_UNARCHIVE_OPERATIONS
    },
    ARCHIVED_SAMPLES: {
        id: 'ARCHIVED_SAMPLES',
        url: 'cases/samples/archived',
        areElementsArchived: true,
        entityType: COREENTITY_VALUES.SAMPLE,
        operations: ARCHIVE_GROUPED_OPERATIONS.SAMPLE_UNARCHIVE_OPERATIONS
    },
    PORTIONS_TO_BE_ARCHIVED: {
        id: 'PORTIONS_TO_BE_ARCHIVED',
        url: 'cases/samples/portions/pendingToBeArchived',
        areElementsArchived: false,
        entityType: COREENTITY_VALUES.PORTION,
        operations: ARCHIVE_GROUPED_OPERATIONS.PORTION_ARCHIVE_OPERATIONS
    },
    PORTIONS_TO_BE_UNARCHIVED: {
        id: 'PORTIONS_TO_BE_UNARCHIVED',
        url: 'cases/samples/portions/pendingToBeUnarchived',
        areElementsArchived: true,
        areElementsPendingUnarchiving: true,
        entityType: COREENTITY_VALUES.PORTION,
        operations: ARCHIVE_GROUPED_OPERATIONS.PORTION_UNARCHIVE_OPERATIONS
    },
    ARCHIVED_PORTIONS: {
        id: 'ARCHIVED_PORTIONS',
        url: 'cases/samples/portions/archived',
        areElementsArchived: true,
        entityType: COREENTITY_VALUES.PORTION,
        operations: ARCHIVE_GROUPED_OPERATIONS.PORTION_UNARCHIVE_OPERATIONS
    },
    SUBPORTIONS_TO_BE_ARCHIVED: {
        id: 'SUBPORTIONS_TO_BE_ARCHIVED',
        url: 'cases/samples/portions/subportions/pendingToBeArchived',
        areElementsArchived: false,
        entityType: COREENTITY_VALUES.SUBPORTION,
        operations: ARCHIVE_GROUPED_OPERATIONS.SUBPORTION_ARCHIVE_OPERATIONS
    },
    SUBPORTIONS_TO_BE_UNARCHIVED: {
        id: 'SUBPORTIONS_TO_BE_UNARCHIVED',
        url: 'cases/samples/portions/subportions/pendingToBeUnarchived',
        areElementsArchived: true,
        areElementsPendingUnarchiving: true,
        entityType: COREENTITY_VALUES.SUBPORTION,
        operations: ARCHIVE_GROUPED_OPERATIONS.SUBPORTION_UNARCHIVE_OPERATIONS
    },
    ARCHIVED_SUBPORTIONS: {
        id: 'ARCHIVED_SUBPORTIONS',
        url: 'cases/samples/portions/subportions/archived',
        areElementsArchived: true,
        entityType: COREENTITY_VALUES.SUBPORTION,
        operations: ARCHIVE_GROUPED_OPERATIONS.SUBPORTION_UNARCHIVE_OPERATIONS
    }
}

export default {
    sideBarName: 'ArchiveSideBar',
    expanded: [
        {
            id: 'pendingArchiving',
            label: 'archive.sidebar.pending',
            icon: ['fal', 'file-alt'],
            hasChildren: true,
            children: [
                {
                    id: 'pendingArchiving',
                    label: 'archive.sidebar.pendingArchiving',
                    hasChildren: true,
                    icon: ['fal', 'inbox-in'],
                    children: [
                        {
                            id: 'samplesToBeArchivedCount',
                            label: 'archive.sidebar.samples',
                            parentLabel: 'archive.sidebar.pendingArchiving',
                            hasChildren: false,
                            icon: ['fal', 'prescription-bottle'],
                            filterModel: {},
                            uicomponent: 'uicomponent.archive.filter.samples.toBeArchived',
                            task: ARCHIVE_TASK.SAMPLES_TO_BE_ARCHIVED
                        },
                        {
                            id: 'paraffinBlocksToBeArchivedCount',
                            label: 'archive.sidebar.paraffinBlocks',
                            parentLabel: 'archive.sidebar.pendingArchiving',
                            hasChildren: false,
                            alticon: PORTION_TYPES.PARAFFIN_BLOCK.icon,
                            filterModel: {},
                            filterParams: {
                                entitySubtype: PORTION_TYPES.PARAFFIN_BLOCK.key
                            },
                            uicomponent: 'uicomponent.archive.filter.paraffinBlocks.toBeArchived',
                            task: ARCHIVE_TASK.PORTIONS_TO_BE_ARCHIVED
                        },
                        {
                            id: 'frozenBlocksToBeArchivedCount',
                            label: 'archive.sidebar.frozenBlocks',
                            parentLabel: 'archive.sidebar.pendingArchiving',
                            hasChildren: false,
                            alticon: PORTION_TYPES.FROZEN_BLOCK.icon,
                            filterModel: {},
                            filterParams: {
                                entitySubtype: PORTION_TYPES.FROZEN_BLOCK.key
                            },
                            uicomponent: 'uicomponent.archive.filter.frozenBlocks.toBeArchived',
                            task: ARCHIVE_TASK.PORTIONS_TO_BE_ARCHIVED

                        },
                        {
                            id: 'subportionsToBeArchivedCount',
                            label: 'archive.sidebar.slides',
                            parentLabel: 'archive.sidebar.pendingArchiving',
                            hasChildren: false,
                            alticon: SUBPORTION_TYPES.SLIDE.icon,
                            filterModel: {},
                            filterParams: {
                                entitySubtype: SUBPORTION_TYPES.SLIDE.key
                            },
                            uicomponent: 'uicomponent.archive.filter.subportions.toBeArchived',
                            task: ARCHIVE_TASK.SUBPORTIONS_TO_BE_ARCHIVED
                        }
                    ]
                },
                {
                    id: 'pendingRemoving',
                    label: 'archive.sidebar.pendingRemoving',
                    hasChildren: true,
                    icon: ['fal', 'inbox-out'],
                    children: [
                        {
                            id: 'samplesToBeUnarchivedCount',
                            label: 'archive.sidebar.samples',
                            parentLabel: 'archive.sidebar.pendingRemoving',
                            hasChildren: false,
                            icon: ['fal', 'prescription-bottle'],
                            filterModel: {},
                            uicomponent: 'uicomponent.archive.filter.samples.toBeUnarchived',
                            task: ARCHIVE_TASK.SAMPLES_TO_BE_UNARCHIVED
                        },
                        {
                            id: 'paraffinBlocksToBeUnarchivedCount',
                            label: 'archive.sidebar.paraffinBlocks',
                            parentLabel: 'archive.sidebar.pendingRemoving',
                            hasChildren: false,
                            alticon: PORTION_TYPES.PARAFFIN_BLOCK.icon,
                            filterModel: {},
                            filterParams: {
                                entitySubtype: PORTION_TYPES.PARAFFIN_BLOCK.key
                            },
                            uicomponent: 'uicomponent.archive.filter.paraffinBlocks.toBeUnarchived',
                            task: ARCHIVE_TASK.PORTIONS_TO_BE_UNARCHIVED
                        },
                        {
                            id: 'frozenBlocksToBeUnarchivedCount',
                            label: 'archive.sidebar.frozenBlocks',
                            parentLabel: 'archive.sidebar.pendingRemoving',
                            hasChildren: false,
                            alticon: PORTION_TYPES.FROZEN_BLOCK.icon,
                            filterModel: {},
                            filterParams: {
                                entitySubtype: PORTION_TYPES.FROZEN_BLOCK.key
                            },
                            uicomponent: 'uicomponent.archive.filter.frozenBlocks.toBeUnarchived',
                            task: ARCHIVE_TASK.PORTIONS_TO_BE_UNARCHIVED
                        },
                        {
                            id: 'subportionsToBeUnarchivedCount',
                            label: 'archive.sidebar.slides',
                            parentLabel: 'archive.sidebar.pendingRemoving',
                            hasChildren: false,
                            alticon: SUBPORTION_TYPES.SLIDE.icon,
                            filterModel: {},
                            filterParams: {
                                entitySubtype: SUBPORTION_TYPES.SLIDE.key
                            },
                            uicomponent: 'uicomponent.archive.filter.subportions.toBeUnarchived',
                            task: ARCHIVE_TASK.SUBPORTIONS_TO_BE_UNARCHIVED
                        }
                    ]
                }
            ]
        },
        {
            id: 'archive',
            label: 'archive.sidebar.archive',
            icon: ['fal', 'file-alt'],
            hasChildren: true,
            children: [
                {
                    id: 'archiveSamples',
                    label: 'archive.sidebar.samples',
                    parentLabel: 'archive.sidebar.archive',
                    hasChildren: false,
                    icon: ['fal', 'prescription-bottle'],
                    filterModel: {},
                    uicomponent: 'uicomponent.archive.filter.samples.archived',
                    task: ARCHIVE_TASK.ARCHIVED_SAMPLES

                },
                {
                    id: 'archiveParaffinBlock',
                    label: 'archive.sidebar.paraffinBlocks',
                    parentLabel: 'archive.sidebar.archive',
                    hasChildren: false,
                    alticon: PORTION_TYPES.PARAFFIN_BLOCK.icon,
                    filterModel: {},
                    filterParams: {
                        entitySubtype: PORTION_TYPES.PARAFFIN_BLOCK.key
                    },
                    uicomponent: 'uicomponent.archive.filter.paraffinBlocks.archived',
                    task: ARCHIVE_TASK.ARCHIVED_PORTIONS
                },
                {
                    id: 'archiveFrozenBLock',
                    label: 'archive.sidebar.frozenBlocks',
                    parentLabel: 'archive.sidebar.archive',
                    hasChildren: false,
                    alticon: PORTION_TYPES.FROZEN_BLOCK.icon,
                    filterParams: {
                        entitySubtype: PORTION_TYPES.FROZEN_BLOCK.key
                    },
                    uicomponent: 'uicomponent.archive.filter.frozenBlocks.archived',
                    task: ARCHIVE_TASK.ARCHIVED_PORTIONS
                },
                {
                    id: 'archiveSubportions',
                    label: 'archive.sidebar.slides',
                    parentLabel: 'archive.sidebar.archive',
                    hasChildren: false,
                    alticon: SUBPORTION_TYPES.SLIDE.icon,
                    filterParams: {
                        entitySubtype: SUBPORTION_TYPES.SLIDE.key
                    },
                    uicomponent: 'uicomponent.archive.filter.subportions.archived',
                    task: ARCHIVE_TASK.ARCHIVED_SUBPORTIONS
                }
            ]
        }
    ],
    module: {
        icon: ['fal', 'archive'],
        name: 'archive.sidebar.archiveManagement'
    }
}
